module.exports = __webpack_public_path__ + "img/zoho_circle.6bbd1a0f.svg";